/**
 * Palet semantik untuk seluruh chart AKAS.
 *
 * Warna chart sengaja tidak mengikuti primary color toko. Dengan begitu,
 * arti sebuah series tetap sama di setiap outlet dan setiap halaman:
 * lime = nilai masuk/bertumbuh, ink = nilai keluar, dan warna status hanya
 * dipakai untuk kondisi yang memang membutuhkan perhatian.
 */
export const AKAS_CHART_COLORS = Object.freeze({
  moneyIn: "#b7ef4a",
  moneyInDeep: "#7fa83a",
  moneyOut: "#17373c",
  moneyOutSoft: "#5f7679",
  neutral: "#94a3a6",
  warning: "#e8ad45",
  danger: "#d95d55",
  info: "#4f8fa3",
  grid: "#e2e8e1",
});

export const AKAS_INVENTORY_STATUS_COLORS = Object.freeze({
  out_of_stock: AKAS_CHART_COLORS.danger,
  critical: AKAS_CHART_COLORS.warning,
  reorder_soon: "#d9853d",
  overstock: AKAS_CHART_COLORS.info,
  healthy: AKAS_CHART_COLORS.moneyInDeep,
});

